module.exports = __webpack_public_path__ + "media/images/hr/dot-2ee7bf6196a52383e3a2a6932207a572.svg";